module.exports = __webpack_public_path__ + "static/img/logo.25f5b20d.png";